
import React, { createContext, useContext, useState } from "react";
import { Task } from "@/context/TaskContext";

interface TaskDetailModalContextType {
  task: Task | null;
  open: (task: Task) => void;
  close: () => void;
  isOpen: boolean;
}

const TaskDetailModalContext = createContext<TaskDetailModalContextType | undefined>(undefined);

export function TaskDetailModalProvider({ children }: { children: React.ReactNode }) {
  const [task, setTask] = useState<Task | null>(null);
  const isOpen = !!task;

  const open = (incoming: Task) => setTask(incoming);
  const close = () => setTask(null);

  return (
    <TaskDetailModalContext.Provider value={{ task, open, close, isOpen }}>
      {children}
    </TaskDetailModalContext.Provider>
  );
}

export function useTaskDetailModal() {
  const ctx = useContext(TaskDetailModalContext);
  if (!ctx) throw new Error("useTaskDetailModal must be used within TaskDetailModalProvider");
  return ctx;
}
